(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  ;(function () {
    const mediaQuery = window.matchMedia('(min-width: 768px)')
    const accordions = document.querySelectorAll('footer details')

    function handleViewportChange(e) {
      accordions.forEach((details) => {
        details.open = e.matches
      })
    }

    mediaQuery.addEventListener('change', handleViewportChange)
    handleViewportChange(mediaQuery)
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee-logo"] && !Shopify.designMode) return;
  try {
    
(function() {
  function updateMarqueeWidth() {
    document.querySelectorAll('.marquee-logo-track').forEach(function(track) {
      var copy = track.querySelector('.marquee-logo-content')
      if (copy) {
        track.style.setProperty('--copy-width', copy.offsetWidth + 'px')
      }
    })
  }

  updateMarqueeWidth()
  window.addEventListener('resize', updateMarqueeWidth)
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-pairing"] && !Shopify.designMode) return;
  try {
    
  ;(function () {
    document.querySelectorAll('.product-pairing-form').forEach((form) => {
      form.addEventListener('submit', async (e) => {
        e.preventDefault()
        const button = form.querySelector('button[type="submit"]')
        const originalContent = button.innerHTML

        button.disabled = true
        button.innerHTML = '<span class="size-4 animate-spin">⟳</span>'

        try {
          const formData = new FormData(form)
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            body: formData,
          })

          if (response.ok) {
            button.innerHTML = '<span class="size-4">✓</span>'
            setTimeout(() => {
              button.innerHTML = originalContent
              button.disabled = false
            }, 1500)

            // Dispatch cart update event for header cart count
            document.dispatchEvent(new CustomEvent('cart:updated'))
          } else {
            throw new Error('Failed to add to cart')
          }
        } catch (error) {
          button.innerHTML = originalContent
          button.disabled = false
          console.error('Add to cart error:', error)
        }
      })
    })
  })()

  } catch(e) { console.error(e); }
})();
})();
